import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { RoutingService } from './core/navigation';
import { LocalSettingsService } from './core/storage';
import { LanguageService } from './services/language.service';
import { BadBrowserGuard } from './shared/bad-browser-page/bad-browser.guard';
import { ApplicationStateService } from './shared/security/application-state.service';

@Component({
    selector: 'odq-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();
  private currentMaintenance = false;
  isMaintenance$: Observable<boolean>;

  /**
   * Root component of the application
   */
  constructor(
    private translate: TranslateService,
    private localSettings: LocalSettingsService,
    private routingService: RoutingService,
    private languageService: LanguageService,
    private applicationStateService: ApplicationStateService,
    private badBrowserGuard: BadBrowserGuard) {

    this.languageService.initLocale();

    routingService.loadRouting();

    this.isMaintenance$ = this.applicationStateService.getMaintenanceState();
  }

  ngOnInit(): void {
    if (!this.badBrowserGuard.isSupportedBrowser) {
      this.routingService.navigateToBadBrowser('');
    }

    this.isMaintenance$.pipe(
      tap(maintenance => {
        if (maintenance) {
          this.routingService.navigateToMaintenance('');
          this.currentMaintenance = true;
        } else {
          if (this.currentMaintenance) {
            this.routingService.navigateToHome();
          }

          this.currentMaintenance = false;
        }
      }),
      takeUntil(this.destroy$),
    ).subscribe();

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
